import { Icon, Flex } from '@webkom/lego-bricks';
import { FileText, MailWarning, PiggyBank } from 'lucide-react';
import styles from './HsSection.module.css';

const HsSectionContent = () => {
  return (
    <div className={styles.container}>
      <Flex column gap="var(--spacing-xs)">
        <a
          href="https://drive.google.com/drive/folders/0B81c-8ZaKBCgUjFPS2Nab3VpVWM?resourcekey=0-xn6rSLIJmRJk78ZFzym5sQ&usp=drive_link"
          target="_blank"
          rel="noreferrer"
          className={`${styles.item} ${styles.accentMinutes} ${styles.fullWidthButton}`}
        >
          <Icon iconNode={<FileText size={18} />} />
          <div className={styles.textWrapper}>
            <h4 className={styles.title}>Møtereferater</h4>
            <span className={`secondaryFontColor ${styles.subtext}`}>
              {' '}
              Møtereferater fra HS-møter
            </span>
          </div>
        </a>
        <a
          href="https://portal.mittvarsel.no/skjema/abakus/t3fMsqnZcCaeFX2u.9824?lang=no"
          target="_blank"
          rel="noreferrer"
          className={`${styles.item} ${styles.accentWarning} ${styles.fullWidthButton}`}
        >
          <Icon iconNode={<MailWarning size={18} />} />
          <div className={styles.textWrapper}>
            <h4 className={styles.title}>Varslingsportal</h4>
            <span className={`secondaryFontColor ${styles.subtext}`}>
              Send inn et anonymt varsel
            </span>
          </div>
        </a>
        <a
          href="https://drive.google.com/drive/folders/1ioLyk3MFFeNaZWNItYEGhdumytFdShmL?usp=sharing"
          target="_blank"
          rel="noreferrer"
          className={`${styles.item} ${styles.accentMoneyRequest} ${styles.fullWidthButton}`}
        >
          <Icon iconNode={<PiggyBank size={18} />} />
          <div className={styles.textWrapper}>
            <h4 className={styles.title}>Pengesøknader</h4>
            <span className={`secondaryFontColor ${styles.subtext}`}>
              Se pengesøknader sendt inn til HS
            </span>
          </div>
        </a>
      </Flex>
    </div>
  );
};

export default HsSectionContent;
